import Api from "../../../services/Api";

const BASE_URL = "/service/iqevse-csms/roles/v1";

export const roleApi = {
  getAllRoles: async () => {
    const response = await Api.get(`${BASE_URL}/getAllRoles`);
    return response;
  },

  getRoleById: async roleId => {
    const response = await Api.get(`${BASE_URL}/${roleId}`);
    return response;
  },

  createRole: async roleData => {
    const response = await Api.post(BASE_URL, roleData);
    return response;
  },

  updateRole: async (roleId, roleData) => {
    const response = await Api.put(`${BASE_URL}/${roleId}`, roleData);
    return response;
  },

  deleteRole: async roleId => {
    const response = await Api.delete(`${BASE_URL}/${roleId}`);
    return response;
  },

  getRolePermissions: async roleId => {
    const response = await Api.get(`${BASE_URL}/${roleId}/permissions`);
    return response;
  },
};
